import { rawColors } from "../../../../design-system/tokens/colors";
import type { KgFlowNodeType } from "../types";

/**
 * Edge stroke color = the target node's own border/accent color.
 * Rule: whichever node the edge is pointing TO, use that node's accent token.
 * This keeps edges visually "owned" by their destination and matches the
 * accent color already used on each node card's border and icon.
 */
export const getEdgeColor = (
  _fromType: KgFlowNodeType | undefined,
  toType: KgFlowNodeType | undefined,
): string => {
  switch (toType) {
    case "dataSource":
      return rawColors.accent.amber500;
    case "schema":
      return rawColors.accent.green;
    case "table":
      return rawColors.accent.tableBlue;
    case "ontology":
      return rawColors.accent.ontologyGreen;
    case "metric":
      return rawColors.accent.metricBlue;
    case "report":
      return rawColors.accent.pink;
    case "dataStory":
      return rawColors.accent.dataStoryPurple;
    case "artifact":
      return rawColors.accent.artifactBlue;
    default:
      return rawColors.stroke[300];
  }
};

/**
 * Human-readable relationship label for an edge between two tier types.
 * Used as the React Flow `label` prop on every edge.
 */
export const getEdgeLabel = (
  fromType: KgFlowNodeType | undefined,
  toType: KgFlowNodeType | undefined,
): string => {
  if (fromType === "dataSource" && toType === "schema")   return "contains";
  if (fromType === "schema" && toType === "table")        return "ingests";
  if (fromType === "dataSource" && toType === "table")    return "ingests";
  if (fromType === "table"      && toType === "ontology") return "classifies";
  if (fromType === "ontology"   && toType === "metric")   return "measures";
  if (fromType === "metric" && toType === "report") return "powers";
  if (fromType === "report" && toType === "dataStory") return "published in";
  if (fromType === "dataStory" && toType === "artifact") return "exports to";
  return "relates to";
};
